export type CogLEDPatternCheckerColour = {
  led: string;
  lcd: string;
}

export type CogLedLcdColours = Array<CogLEDPatternCheckerColour>;

export type CogServoFaultFlags = {
  intermittentConnection: boolean,
  noConnection: boolean,
  faultyConnection: boolean,
  servoHornPositionError: boolean
};

export class CogCalibInfo {
  rslt = '';
  calDone = 0;
  validMs? = 0;
}

export interface SimplifiedCogStateInfo {
  accelerometer: {
    ax: number;
    ay: number;
    az: number;
  };
  gyroscope: {
    gx: number;
    gy: number;
    gz: number;
  };
  light: {
    amb0: number;
    ir0: number;
    ir1: number;
    ir2: number;
  };
  power: {
    battV: number;
    usb: string;
  };
}